import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-805"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M0 8a8 8 0 1 0 8-8 8 8 0 0 0-8 8zm1 0a7.008 7.008 0 0 1 7-7 6.613 6.613 0 0 1 .881.063.702.702 0 0 1 .36.157A8.868 8.868 0 0 1 12.036 8a8.838 8.838 0 0 1-2.849 6.822.486.486 0 0 1-.24.106A6.73 6.73 0 0 1 8 15a7.008 7.008 0 0 1-7-7z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }